import { render } from "./TargetShareDialog.vue?vue&type=template&id=68f9e685"
import script from "./TargetShareDialog.vue?vue&type=script&lang=ts"
export * from "./TargetShareDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script